export const gql = {
  animals: `query animal($guid: String!) {
    animals(guid: $guid) {
      guid
      sgtin
      allflex
      visualTag
      owner
      producer
      events {
        time
        mass
        type
        sourceKraal
        destinationKraal
        brokenNeedle
        station {
          guid
          description
        }
        reference
        system
        temperature
        ailment
        treatment
        vaccination
        doses {
          item
          dosage
          unit
          injected
          withdrawal
        }
        withdrawal
        adg
        days
        massDiff
        notes
      }
      breed
      gender
      customFeeder {
        guid
        name
        surname
        companies {
          typename
          guid
          name
          active
        }
      }
      species
    }
  }`
};

export const changeTrackingComponentFragment = `
fragment changeTrackingFields on ChangeTrackComponent {
  current {
    guid
    hash
  }
  previous {
    guid
    hash
  }
  serverSaveTime
  save {
    uid
    time
  }
}`;
